import type { MouseEvent } from "react";

import { Button, ButtonTypes } from "@repo/ui";

import type { ApplicationSetting } from "../../../models";

import style from "./style.module.scss";

interface Props {
	setting: ApplicationSetting;
	onEdit: (setting: ApplicationSetting) => void;
	onDelete: (setting: ApplicationSetting) => void;
}

/** Edit and Delete buttons for one setting row. A click stops here, so it doesn't also open the row it sits in */
export function SettingRowActions({ setting, onEdit, onDelete }: Props) {
	function handle(action: (setting: ApplicationSetting) => void) {
		return (event: MouseEvent) => {
			event.stopPropagation();
			action(setting);
		};
	}

	return (
		<div className={style.rowActions}>
			<Button types={[ButtonTypes.Text]} title="Edit this row" onClick={handle(onEdit)}>
				Edit
			</Button>
			<Button types={[ButtonTypes.Text]} title="Delete this row" onClick={handle(onDelete)}>
				Delete
			</Button>
		</div>
	);
}
